import {
  api
} from './apis'

export const getUserInfo = () => {
  return api.get(`/userInfo`)
}



// WEBPACK FOOTER //
// ./src/utils/service.js